import ScrollView from 'devextreme-react/scroll-view';
import React, { useEffect } from 'react';

const WCAGComponent = () => {
    const loadWcagScript = async () => {
        try {
            const scriptElement = document.createElement('script');
            scriptElement.src = 'https://wcag.cui.wroclaw.pl/Scripts/wcag.js';
            document.head.appendChild(scriptElement);

            await new Promise((resolve) => {
                scriptElement.onload = resolve;
            });

            if (window.showWcagDeclaration) {
                window.showWcagDeclaration('0a4f8d0f-6e09-476b-946c-0697a9b8ce17', '#wcag-declaration');
            } 
        } catch (error) {
            console.error('Błąd podczas ładowania skryptu wcag.js:', error);
        }
    };

    useEffect(() => {
        loadWcagScript();
    }, []);

    return (
        <ScrollView>
            <div id="wcag-declaration"></div>
        </ScrollView>
    );
};

export default WCAGComponent;
